<template>
  <div>

    <el-row v-if="globalConfig && globalConfig.switch_qr" :gutter="10">

      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <div>
          <img class="img" src="../assets/qrc.jpg" />
        </div>
      </el-col>

      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <div>
          <img class="img" src="../assets/zsm.jpg" />
        </div>
      </el-col>

    </el-row>
  </div>
</template>

<script>

export default {
  name: 'AboutMe',
  components: {
  },
  props: {
    globalConfig: Object
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.img {
  width: 100%;
}
</style>
